import { useContext } from 'react';
import SearchPoolContext from '../contexts/SearchPoolContext';

export default function useSearchPoolContext() {
  return useContext(SearchPoolContext);
}
